









import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { format } from '@/utils/helper';
import { IClientCrashList } from '@/store/home/stats/types';
import DataTable from '../../common/DataTable.vue';

const Stats = namespace('home/stats');

@Component({
  components: { DataTable },
})
export default class ClientCrashTable extends Vue {
  @Stats.State('clientCrashList') public list!: IClientCrashList;

  public headers = [
    { text: '报告日期', value: 'reportTime', width: 160 },
    { text: '操作系统', value: 'osVersion' },
    { text: '报告人', value: 'userName' },
  ];

  public get items() {
    return this.list.data.map((item) => {
      const reportTime = format(item.reportTime || '', true);
      return { ...item, reportTime };
    });
  }
}
